"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendUri = void 0;
function appendUri(uri, query) {
    if (query === void 0) { query = {}; }
    var hasQuery = uri.indexOf('?') !== -1;
    var newQuery = Object.keys(query).reduce(function (accu, curr, idx) {
        return "" + accu + ((idx === 0 && !hasQuery) ? '?' : '&') + curr + "=" + query[curr];
    }, '');
    return uri + newQuery;
}
exports.appendUri = appendUri;
//# sourceMappingURL=appendUri.js.map